import citizen_contract from '../../../../build/contracts/Citizens.json'
import store from '../../../store'

const contract = require('truffle-contract')

export const ADD_CITIZENS = 'ADD_CITIZENS'
function citizensUpdated(citizens) {
    return {
        type: ADD_CITIZENS,
        payload: citizens
    }
}

function getAll(cInstance, dispatch, page, i, citizens, next, perCitizen){

    cInstance.members(i).then((result) => {
       
        citizens.push({citizenAddress:result[0].toString(),citizenName:result[1].toString(),
            citizenSince:result[2].toString(),citizenId:i});

        if (perCitizen === citizens.length){
			
            citizens.sort(function(a, b){
                return b.citizenId-a.citizenId
            })

            return dispatch(citizensUpdated({'citizens':citizens,'activePage':page}))
        }
		
    })

}

export function getCitizens(allCitizens, page) {
  
    let web3 = store.getState().web3.web3Instance

    if (typeof web3 !== 'undefined') {

        return function(dispatch) {
		
            let cInstance
            let perCitizen = 5
            let citizens = []
            let more = perCitizen * page
            let next = allCitizens - more
            if (page > 1){
                let prev = page - 1
                allCitizens -= perCitizen * prev
            }
            if (next <= 0){
                next = 0
                perCitizen = allCitizens
            }
		
            const CitizenContract = contract(citizen_contract)
            CitizenContract.setProvider(web3.currentProvider)

            CitizenContract.deployed().then((contractInstance) => {
                cInstance = contractInstance	
			
                for(let i = allCitizens; i > next; i--) {
                    getAll(cInstance, dispatch, page, i, citizens, next, perCitizen)
                }

            })
		
        }
    } else {
        console.error('Web3 is not initialized.');
    }
}



// WEBPACK FOOTER //
// ./src/user/actions/citizens/GetCitizens.js